import { Component, OnInit, Input } from '@angular/core';
import { ParamsService, Search, ListService, ListItem, CrudService } from 'elbuild-ui-lib-core';
import { Router, ActivatedRoute } from '@angular/router';
import { CompanyStatus, Provincia, Company } from 'toolbandi-ui-lib';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-employee-list-filters',
	templateUrl: './employee-list-filters.component.html',
	styleUrls: ['./employee-list-filters.component.scss']
})
export class EmployeeListFiltersComponent extends ListFiltersComponent implements OnInit {

	keyword: string;
	active: boolean = true;
	provinciaSearch = new Search('province');
	provincia: Provincia;
	contracttypes: ListItem[];
	contractlevels: ListItem[];

	daylyhrs = { from: undefined, to: undefined, min: 0, max: 12 };
	basehourlysalary = { from: undefined, to: undefined, min: 0, max: 1000 };

	@Input()
	companyid: number;
	company: {
		search: Search,
		selected: Company
	};

	constructor(router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService,
		private listService: ListService) {
		super(router, _route, paramsService);

		this.listService.getListItemsBySlug('contract.type').subscribe(data => this.contracttypes = data);
		this.listService.getListItemsBySlug('contract.level').subscribe(data => this.contractlevels = data);

		this.company = {
			search: new Search('company'),
			selected: undefined
		};


	}

	ngOnInit() {
		this.setParams();
	}

	readQueryParams(params: string) {
		super.readQueryParams(params);

	}

	resetSearch() {
		this.keyword = undefined;
		this.active = true;
		this.provincia = undefined;
		this.daylyhrs.from = undefined;
		this.daylyhrs.to = undefined;
		this.basehourlysalary.from = undefined;
		this.basehourlysalary.to = undefined;
		super.resetSearch();
	}

	search(keeppage?: boolean) {
		this.setProvince();
		this.setDaylyhrs();
		this.setBasehourlysalary();
		this.setCompany();
		super.search(keeppage);
		this.setParams();
	}

	setProvince(): void {
		if (this.provincia) {
			this.searchparams.simpleTmp['province'] = this.provincia.descrizione;
		}
	}

	setDaylyhrs(): void {
		if ((this.daylyhrs.to || this.daylyhrs.to === 0) && !this.daylyhrs.from) this.daylyhrs.from = this.daylyhrs.min;
		if ((this.daylyhrs.from || this.daylyhrs.from === 0) && !this.daylyhrs.to) this.daylyhrs.to = this.daylyhrs.max;

		if (this.daylyhrs.from && this.daylyhrs.from < this.daylyhrs.min) this.daylyhrs.from = this.daylyhrs.min;
		if (this.daylyhrs.to && this.daylyhrs.to < this.daylyhrs.min) this.daylyhrs.to = this.daylyhrs.min;
		if (this.daylyhrs.from && this.daylyhrs.from > this.daylyhrs.max) this.daylyhrs.from = this.daylyhrs.max;
		if (this.daylyhrs.to && this.daylyhrs.to > this.daylyhrs.max) this.daylyhrs.to = this.daylyhrs.max;

		this.searchparams.rangeTmp['daylyhrs'] = { start: this.daylyhrs.from, stop: this.daylyhrs.to };
	}

	setBasehourlysalary(): void {
		if ((this.basehourlysalary.to || this.basehourlysalary.to === 0) && !this.basehourlysalary.from)
			this.basehourlysalary.from = this.basehourlysalary.min;
		if ((this.basehourlysalary.from || this.basehourlysalary.from === 0) && !this.basehourlysalary.to)
			this.basehourlysalary.to = this.basehourlysalary.max;

		if (this.basehourlysalary.from && this.basehourlysalary.from < this.basehourlysalary.min)
			this.basehourlysalary.from = this.basehourlysalary.min;
		if (this.basehourlysalary.to && this.basehourlysalary.to < this.basehourlysalary.min)
			this.basehourlysalary.to = this.basehourlysalary.min;
		if (this.basehourlysalary.from && this.basehourlysalary.from > this.basehourlysalary.max)
			this.basehourlysalary.from = this.basehourlysalary.max;
		if (this.basehourlysalary.to && this.basehourlysalary.to > this.basehourlysalary.max)
			this.basehourlysalary.to = this.basehourlysalary.max;

		this.searchparams.rangeTmp['basehourlysalary'] = { start: this.basehourlysalary.from, stop: this.basehourlysalary.to };
	}

	setCompany(): void {
		if (this.company.selected) {
			this.searchparams.addSimpleFilter('companyid', this.company.selected.id);
		}
	}

	setParams() {
		/*if (this.active) {
			this.searchparams.addSimpleFilter('status', CompanyStatus.ACTIVE);
		} else {
			this.searchparams.removeSimpleFilter('status');
		}*/

	}

}
